import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getUser } from '../../redux/modules/user';

class AuthenticationRoute extends Route {
  isValidRouting = () => {
    /** withAuth can take false/true/undefined
     * false - means that you can enter the route only if you are not authenticated
     * true - means that you can enter the route only if you are authenticated
     * undefined - create auth insensitive route, meaning that you can enter it in any case
     */
    const { withAuth, isAuthenticated } = this.props;

    if (withAuth === undefined) {
      return true;
    }

    return withAuth ? isAuthenticated : !isAuthenticated;
  };

  resolveRedirectPath = () => {
    const { redirectOnFailure, location } = this.props;

    if (redirectOnFailure) {
      return redirectOnFailure;
    }

    // Redirect to the route, the user tried to access
    // right before authentication
    return location.state ? location.state.from : '/';
  };

  componentDidMount() {
    this.handleGetUser();
  }

  componentDidUpdate() {
    this.handleGetUser();
  }

  handleGetUser = () => {
    const { user, withAuth, isAuthenticated } = this.props;
    if (withAuth && isAuthenticated && !user) {
      this.props.getUser();
    }
  };

  render() {
    const { location } = this.props;
    const redirectOnFailure = this.resolveRedirectPath();

    return this.isValidRouting() ? (
      super.render()
    ) : (
      <Redirect
        to={{
          pathname: redirectOnFailure,
          state: { from: location.pathname },
        }}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  user: state.userReducer.user,
});
const mapDispatchToProps = {
  getUser,
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(AuthenticationRoute);
